import type { ReactNode } from 'react';
import React from 'react';

export const filterChildrenByType = <T>(
  children: ReactNode,
  types: React.ComponentType<any>[] | React.ComponentType<any>,
) => {
  const typeArray = Array.isArray(types) ? types : [types];
  return React.Children.toArray(children).filter(
    (el): el is React.ReactElement<T> =>
      React.isValidElement(el) && typeArray.some((type) => el.type === type),
  );
};
